import { INITIATOR_REQUEST } from 'Constants/Address.constants'
import { FmsUnitModel } from 'Modules'
import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'

const getAll = async (params: { origin: INITIATOR_REQUEST; query: string }) => {
	const res = await axiosDS().get<FmsUnitModel[]>(`${urls.cabinet.suggest_fms_unit}`, {
		params,
	})
	return res.data
}

export const fmsUnitsApi = {
	getAll,
}
